export enum RouteSegmentEnum {
  ACTIVITY = 'activity',
  CHECK_IN = 'check-in',
  FORBIDDEN = 'forbidden',
  HOME = 'home',
  LOGIN = 'login',
  PRIVACY_POLICY = 'privacy-policy',
  PROFILE = 'profile',
  REGISTER = 'register',
  RESET = 'reset',
  SET_PASSWORD = 'user/password/set',
  COACH = 'coach',
  USER = 'user',
  VERIFICATION = 'user/verify',
  WEIGHT = 'weight',
  EVENTS = 'events',
}

export enum RoutesEnum {
  COACH_ACTIVITY = `${RouteSegmentEnum.COACH}/${RouteSegmentEnum.ACTIVITY}`,
  COACH_CHECK_IN = `${RouteSegmentEnum.COACH}/${RouteSegmentEnum.CHECK_IN}`,
  COACH_EVENTS = `${RouteSegmentEnum.COACH}/${RouteSegmentEnum.EVENTS}`,
  COACH_HOME = `${RouteSegmentEnum.COACH}/${RouteSegmentEnum.HOME}`,
  COACH_PROFILE = `${RouteSegmentEnum.COACH}/${RouteSegmentEnum.PROFILE}`,
  COMMON_FORBIDDEN = RouteSegmentEnum.FORBIDDEN,
  COMMON_LOGIN = RouteSegmentEnum.LOGIN,
  COMMON_PRIVACY_POLICY = RouteSegmentEnum.PRIVACY_POLICY,
  COMMON_REGISTER = RouteSegmentEnum.REGISTER,
  COMMON_RESET = RouteSegmentEnum.RESET,
  COMMON_SET_PASSWORD = RouteSegmentEnum.SET_PASSWORD,
  COMMON_USER_VERIFICATION = RouteSegmentEnum.VERIFICATION,
  USER_CHECK_IN = `${RouteSegmentEnum.USER}/${RouteSegmentEnum.CHECK_IN}`,
  USER_HOME = `${RouteSegmentEnum.USER}/${RouteSegmentEnum.HOME}`,
  USER_PROFILE = `${RouteSegmentEnum.USER}/${RouteSegmentEnum.PROFILE}`,
  USER_WEIGHT = `${RouteSegmentEnum.USER}/${RouteSegmentEnum.WEIGHT}`,
}
